import React from 'react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

interface MobileMenuToggleProps {
  isOpen: boolean
  onToggle: () => void
}

export default function MobileMenuToggle({ isOpen, onToggle }: MobileMenuToggleProps) {
  return (
    <>
      <button
        className="mobile-menu-toggle"
        onClick={onToggle}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
      >
        {isOpen ? (
          <XMarkIcon className="w-6 h-6" />
        ) : (
          <Bars3Icon className="w-6 h-6" />
        )}
      </button>
      
      {/* Backdrop */}
      <div 
        className={`sidebar-backdrop ${isOpen ? 'active' : ''}`}
        onClick={onToggle}
        style={{ display: isOpen ? 'block' : 'none' }}
      />
    </>
  )
}